import { Card, Flex, Table, Text } from '@chakra-ui/react'
import type React from 'react'

export interface DetailRowProps {
  label: string
  children: React.ReactNode
}

/**
 * Key-value row inside a DetailSection.
 * Designed to be easily migrated to @mangovoice/mango-ui.
 */
export const DetailRow: React.FC<DetailRowProps> = ({ label, children }) => (
  <Table.Row>
    <Table.Cell
      fontWeight="600"
      fontSize="sm"
      whiteSpace="nowrap"
      width="40%"
      py={2.5}
    >
      {label}
    </Table.Cell>
    <Table.Cell fontSize="sm" textAlign="right" py={2.5}>
      {children}
    </Table.Cell>
  </Table.Row>
)

export interface DetailSectionProps {
  title: string
  children: React.ReactNode
  /** Optional control rendered on the right side of the section header. */
  headerAction?: React.ReactNode
}

/**
 * Card with a header and key-value table body.
 * Designed to be easily migrated to @mangovoice/mango-ui.
 */
export const DetailSection: React.FC<DetailSectionProps> = ({
  title,
  children,
  headerAction,
}) => (
  <Card.Root variant="outline" mb={4} overflow="hidden">
    <Flex
      bg="bg.subtle"
      px={4}
      py={2.5}
      borderBottomWidth="1px"
      align="center"
      justify="space-between"
      gap={2}
      minH="44px"
    >
      <Text fontWeight="600" fontSize="sm">
        {title}
      </Text>
      {headerAction}
    </Flex>
    <Table.Root size="sm" variant="line">
      <Table.Body>{children}</Table.Body>
    </Table.Root>
  </Card.Root>
)
